import { mutatorAction } from 'satcheljs';
import { FeedActionType } from '../store/feedAction';
import { getActivityFeedStore } from '../store/store';
import { getPromptFeedActionCard } from './getPromptFeedActionCard';
import { ActivityFeedItem } from '../service/ActivityFeedItem';

export const promptUpdateHost = mutatorAction('PROMPT_UPDATE_HOST', (callback: () => void) => {
    const store = getActivityFeedStore();
    store.feedAction.promptFeedAction = true;
    store.feedAction.type = FeedActionType.PromptUpdateNativeHost;
    store.feedAction.feedActionCallback = callback;

    const cardId = 'LocalActivity-PromptAction';
    const card: ActivityFeedItem = getPromptFeedActionCard(cardId);
    store.items.set(cardId, card);
});
